import { ContentfulAsset } from '../Contentful';
import styled, { css } from 'styled-components';
import { UnstyledLink } from '../ui';
import { screenMdMin, spacer32 } from '@spotify-internal/encore-foundation';

export interface FaqArticle {
  question: string;
  urlSlug: string;
  answer: string;
  category?: FaqCategory;
  popular?: boolean;
  id: string;
  contentType: string;
}

export interface FaqCategory {
  name: string;
  description?: string;
  urlSlug: string;
  faqs: FaqArticle[];
  icon?: ContentfulAsset;
  id: string;
  contentType: string;
}

export const isHelpLive = false;

export const HELP_LIST_TRACK_CAT = 'Help List';
export const categoryTrackLabel = (category?: FaqCategory) =>
  `Category - ${category?.name || 'Unknown'}`;
export const articleTrackLabel = (article: FaqArticle) =>
  `Article - ${article.question}`;
const baseUrl = '/help';
export const categoryUrl = (category?: FaqCategory) =>
  `${baseUrl}/${category?.urlSlug}`;
export const articleUrl = (article: FaqArticle, category?: FaqCategory) =>
  `${baseUrl}/article/${article.urlSlug}${
    category ? `?category=${category.urlSlug}` : ''
  }`;
export const LinkWithHelpHighlight = styled(UnstyledLink)`
  &:hover,
  &:focus:not(:disabled),
  &:active:not(:disabled),
  &.highlight {
    color: ${({ theme }) => theme.help.link.text};
  }

  &:focus:not(:hover),
  &:active:not(:hover),
  &.highlight:not(:hover) {
    color: ${({ theme }) => theme.box.text};
  }
`;
export const ChevronLink = styled(UnstyledLink)`
  &:hover,
  &:focus:not(:disabled),
  &:active:not(:disabled),
  &.highlight {
    color: ${({ theme }) => theme.box.text};
  }
`;

export const hidden = css`
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
`;

export const border = css`
  border-bottom: 1px solid ${({ theme }) => theme.help.link.divider};
`;

export const SearchBarContainer = styled.div`
  margin-bottom: ${spacer32};

  @media (min-width: ${screenMdMin}) {
    ${hidden}
  }
`;
